// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
._ag-card {
  margin-bottom: 10px;
  _border: 2px solid #fff;
  border-radius: 7px;
  margin: 8px;
  padding: 16px;
  overflow-y: auto;
  background-color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);
}
*/
.clear-button {
  background: rgba(237, 109, 5, 0.8);
  padding: 4px 10px;
  color: white;
  border-radius: 10px;
  font-size: 16px;
}

.ag-alarm {
  padding: 10px 0;
}

.alarm-card {
  padding: 16px;
}

.ag-alarm-header-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.ag-alarm-icon {
  height: 30px;
  width: 30px;
  _background: lightgray;
  _border-radius: 5px;
  margin-right: 5px;
}

.ag-alarm-message {
  font-size: 14px;
  overflow: hidden;
}

.ag-alarm-value {
  font-weight: bold;
  color: #D9461D;
  font-size: 16px;
}

.ag-alarm-device {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/alarm-page/alarm-page.scss"],"names":[],"mappings":"AACA;;;;;;;;;;;CAAA;AAaA;EACE,kCAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAGA;EACE,eAAA;AAAF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;AAGtC;;AADA;EACE,YAAA;EACA,WAAA;GAIA,qBAHA;GAIA,kBAHA;EACA,iBAAA;AAIF;;AAFA;EACE,eAAA;EACA,gBAAA;AAKF;;AAHA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAMF;;AAJA;EACE,iBAAA;AAOF","sourcesContent":["\r\n/*\r\n._ag-card {\r\n  margin-bottom: 10px;\r\n  _border: 2px solid #fff;\r\n  border-radius: 7px;\r\n  margin: 8px;\r\n  padding: 16px;\r\n  overflow-y: auto;\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\r\n}\r\n*/\r\n\r\n.clear-button {\r\n  background: rgba(237, 109, 5, 0.8);\r\n  padding: 4px 10px;\r\n  color: white;\r\n  border-radius: 10px;\r\n  font-size: 16px;\r\n}\r\n.ag-alarm {\r\n  padding: 10px 0;\r\n}\r\n.alarm-card {\r\n  padding: 16px;\r\n}\r\n\r\n.ag-alarm-header-title {\r\n  font-size: 16px; font-weight: bold; margin-bottom: 5px;\r\n}\r\n.ag-alarm-icon {\r\n  height: 30px;\r\n  width: 30px;\r\n  _background: lightgray;\r\n  _border-radius: 5px;\r\n  margin-right: 5px;\r\n}\r\n.ag-alarm-message {\r\n  font-size: 14px;\r\n  overflow: hidden;\r\n}\r\n.ag-alarm-value {\r\n  font-weight: bold;\r\n  color: #D9461D;\r\n  font-size: 16px;\r\n}\r\n.ag-alarm-device {\r\n  font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
